/* Pagina E: galeria de poze (swipe pe telefon, toate pozele una sub alta pe desktop) și etichetele Clarity. */
(function () {
  var root = document.querySelector('.smx-e');
  if (!root) return;
  var D = {};
  try { D = JSON.parse(document.getElementById('e-data').textContent); } catch (err) {}

  /* ---------- Clarity: eticheta paginii noi și pașii omului ---------- */
  var tagged = false;
  function cl() { return typeof window.clarity === 'function' ? window.clarity : null; }
  function tag() {
    var c = cl();
    if (!c || tagged) return !!tagged;
    try { c('set', 'pdp_design', 'e'); c('set', 'pdp_kind', String(D.kind || '')); c('set', 'pdp_3d', D.has3d ? 'da' : 'nu'); tagged = true; } catch (err) {}
    return tagged;
  }
  function ev(name) { try { var c = cl(); if (c) c('event', name); } catch (err) {} }
  if (!tag()) { var tries = 0, iv = setInterval(function () { if (tag() || ++tries > 30) clearInterval(iv); }, 2000); }
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('[data-pick], a, button') : null;
    if (!t || !root.contains(t)) return;
    var txt = (t.textContent || '').replace(/\s+/g, ' ').trim();
    if (t.hasAttribute('data-pick')) ev('e_pick_' + t.getAttribute('data-pick'));
    else if (/wa\.me/.test(t.getAttribute('href') || '')) ev('e_whatsapp');
    else if (t.getAttribute('data-sheet') === 'mostre') ev('e_mostre');
    else if (/^Adaugă în coș/.test(txt)) ev('e_adauga_in_cos');
    else if (/^Continuă/.test(txt)) ev('e_continua');
    else if (t.id === 'toList' || /^Configurează(-ți)? .*pași|^Alege (mărimea|stofa)/.test(txt)) ev('e_lista_start');
    else if (t.hasAttribute('data-viewer')) ev('e_poze');
    else if (t.hasAttribute('data-e-google')) ev('e_google_recenzii');
  }, true);
  var stepper = document.getElementById('e-stepper');
  if (stepper && 'MutationObserver' in window) {
    var seen = {};
    new MutationObserver(function () {
      Array.prototype.forEach.call(stepper.children, function (li, i) {
        if (/\bdone\b/.test(li.className) && !seen[i]) { seen[i] = 1; ev('e_pas_' + (i + 1) + '_gata'); }
      });
    }).observe(stepper, { subtree: true, attributes: true, attributeFilter: ['class'], childList: true });
  }

  /* ---------- Galeria ---------- */
  var stage = document.getElementById('e-stage');
  var IM = D.images || [];
  var rooms = IM.filter(function (x) { return x.k === 'room'; });
  var studio = IM.filter(function (x) { return x.k === 'rot'; }).sort(function (p, q) { return (+p.a) - (+q.a); });
  var s0 = studio.filter(function (x) { return +x.a === 0; })[0] || studio[0];
  var s45 = studio.filter(function (x) { return +x.a === 45; })[0];
  var ext = IM.filter(function (x) { return x.k === 'ext'; })[0];
  var photos = rooms.concat([s0, s45, ext].filter(Boolean));
  if (!photos.length) photos = IM.slice();
  photos = photos.filter(function (x, i) { return photos.indexOf(x) === i; });
  if (!stage || photos.length < 2) return;

  var name = String(D.short || D.title || '');
  function alt(x) { return name + (x.k === 'room' ? ' în cameră' : x.k === 'ext' ? ' desfăcut în pat' : ', randare'); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  var track = document.createElement('div');
  track.className = 'eg-track';
  track.setAttribute('role', 'region');
  track.setAttribute('aria-roledescription', 'carusel');
  track.setAttribute('aria-label', 'Pozele produsului, ' + photos.length);
  track.tabIndex = 0;
  track.innerHTML = photos.map(function (x, i) {
    return '<figure class="eg-slide" aria-label="Poza ' + (i + 1) + ' din ' + photos.length + '"><img src="' + esc(x.u) + '" srcset="' + esc(x.u) + ' 750w, ' + esc(x.z) + ' 1500w" sizes="(min-width: 990px) 56vw, 100vw" alt="' + esc(alt(x)) + '"' + (i ? ' loading="lazy"' : ' fetchpriority="high"') + ' decoding="async" width="' + (x.w || 1200) + '" height="' + (x.h || 900) + '" draggable="false"></figure>';
  }).join('');
  var count = document.createElement('span');
  count.className = 'eg-count';
  count.setAttribute('aria-live', 'polite');
  var dots = document.createElement('div');
  dots.className = 'eg-dots';
  dots.setAttribute('aria-hidden', 'true');
  dots.innerHTML = photos.map(function (_, i) { return '<i' + (i ? '' : ' class="on"') + '></i>'; }).join('');

  stage.insertBefore(track, stage.firstChild);
  stage.appendChild(count);
  stage.appendChild(dots);
  stage.classList.add('eg-on');
  stage.setAttribute('aria-label', name + ': ' + photos.length + ' poze. Glisează ca să treci de la una la alta, apasă ca s-o vezi mare.');
  var chipN = stage.querySelector('[data-e-photos]');
  if (chipN) chipN.textContent = photos.length;

  /* Rotirea veche a pozei mari ascultă pe #e-stage: evenimentele din galerie nu ajung la ea. */
  ['pointerdown', 'pointermove', 'pointerup', 'pointercancel', 'touchstart', 'touchmove', 'touchend', 'mousedown', 'mousemove', 'mouseup', 'click'].forEach(function (t) {
    track.addEventListener(t, function (e) { e.stopPropagation(); }, { passive: true });
  });

  var idx = 0, shown = document.getElementById('e-shownChip'), swiped = false;
  function setIdx(i) {
    if (i === idx) return;
    idx = i;
    count.textContent = (i + 1) + ' / ' + photos.length;
    Array.prototype.forEach.call(dots.children, function (d, k) { d.className = k === i ? 'on' : ''; });
    if (shown) shown.hidden = photos[i].k !== 'room' || i > 0;
    if (!swiped) { swiped = true; ev('e_galerie_swipe'); }
  }
  count.textContent = '1 / ' + photos.length;
  var raf = 0;
  track.addEventListener('scroll', function () {
    if (raf) return;
    raf = requestAnimationFrame(function () { raf = 0; var w = track.clientWidth || 1; setIdx(Math.max(0, Math.min(photos.length - 1, Math.round(track.scrollLeft / w)))); });
  }, { passive: true });
  track.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
    e.preventDefault();
    var n = Math.max(0, Math.min(photos.length - 1, idx + (e.key === 'ArrowRight' ? 1 : -1)));
    track.scrollTo({ left: n * track.clientWidth, behavior: 'smooth' });
  });

  /* Un tap pe o poză deschide fereastra mare, la poza respectivă. */
  var downX = 0, downY = 0;
  track.addEventListener('pointerdown', function (e) { downX = e.clientX; downY = e.clientY; }, { passive: true });
  track.addEventListener('click', function (e) {
    if (Math.abs(e.clientX - downX) > 8 || Math.abs(e.clientY - downY) > 8) return;
    var fig = e.target.closest ? e.target.closest('.eg-slide') : null;
    if (!fig) return;
    var i = Array.prototype.indexOf.call(track.children, fig);
    var btn = document.getElementById('e-photosChip');
    if (btn) btn.click();
    setTimeout(function () {
      var f = document.querySelectorAll('#e-vbody .vlist figure')[i];
      if (f) f.scrollIntoView({ block: 'start' });
    }, 60);
  });
})();
